export default {
    computed: {
        $_name() { 
            return this.component.name 
        }
    }
}